import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { BRAND, NAV_LINKS } from "../mock/mock";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const dark = onHome && !scrolled; // transparent over hero, solid on scroll / non-home
  const textColor = dark ? "text-white" : "text-black";
  const bgColor = dark
    ? "bg-transparent"
    : "bg-white/95 backdrop-blur-md border-b border-black/10";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${bgColor} ${textColor}`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <span className="font-serif-display text-2xl md:text-3xl font-black tracking-tight">
            {BRAND.short}
          </span>
          <span className="hidden md:block text-[10px] uppercase tracking-[0.28em] opacity-70 group-hover:opacity-100 transition-opacity">
            Adways Marketing Solutions
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="nav-link text-[13px] uppercase tracking-[0.18em] font-medium"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/contact"
            className={`group inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.2em] font-semibold px-5 py-3 border ${
              dark ? "border-white" : "border-black"
            } hover:bg-black hover:text-white transition-colors duration-200 ${
              dark ? "hover:bg-white hover:text-black" : ""
            }`}
          >
            Let's Talk
            <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform duration-300" />
          </Link>
        </div>

        <button
          aria-label="menu"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden p-2 -mr-2"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile sheet */}
      {open && (
        <div className="lg:hidden bg-black text-white border-t border-white/10">
          <div className="px-6 py-8 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-2xl font-display uppercase tracking-wider"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-4 inline-flex items-center gap-2 text-sm uppercase tracking-widest font-semibold px-5 py-3 border border-white w-fit"
            >
              Let's Talk <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
